/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Billing_Addon_BuyInputs */

const en_billing_addon_buy = /** @type {(inputs: Billing_Addon_BuyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top up · ${i?.price}`)
};

const id_billing_addon_buy = /** @type {(inputs: Billing_Addon_BuyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top up · ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Top up · {price}" |
*
* @param {Billing_Addon_BuyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addon_buy = /** @type {((inputs: Billing_Addon_BuyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addon_BuyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addon_buy(inputs)
	return en_billing_addon_buy(inputs)
});